import React from 'react';
import PropTypes from 'prop-types';

const variantClasses = {
  default: 'bg-gray-100 text-gray-800 border-gray-200',
  primary: 'bg-blue-100 text-blue-800 border-blue-200',
  success: 'bg-green-100 text-green-800 border-green-200',
  warning: 'bg-yellow-100 text-yellow-800 border-yellow-200',
  danger: 'bg-red-100 text-red-800 border-red-200',
  info: 'bg-cyan-100 text-cyan-800 border-cyan-200',
  internship: 'bg-blue-500 text-white border-blue-600',
  'full-time': 'bg-green-500 text-white border-green-600',
};

const sizeClasses = {
  sm: 'text-xs px-2 py-0.5 h-5',
  md: 'text-sm px-2.5 py-1 h-6',
  lg: 'text-base px-3 py-1.5 h-7',
};

const Badge = ({
  children,
  variant = 'default',
  size = 'md',
  removable = false,
  onRemove,
  className = '',
}) => {
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-md border font-medium ${variantClasses[variant]} ${sizeClasses[size]} ${className}`}
    >
      {children}
      {removable && onRemove && (
        <button
          type="button"
          onClick={onRemove}
          className="ml-1 inline-flex items-center justify-center hover:opacity-70"
          aria-label="Remove"
        >
          <svg
            className="h-3 w-3"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      )}
    </span>
  );
};

Badge.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf([
    'default',
    'primary',
    'success',
    'warning',
    'danger',
    'info',
    'internship',
    'full-time',
  ]),
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  removable: PropTypes.bool,
  onRemove: PropTypes.func,
  className: PropTypes.string,
};

export default Badge;


